<template>
  <MPopover
    ref="popover"
    :placement="popoverPlacment"
    transition-name="slide-up"
    overlay-class-name="picker-overlay"
    :overlay-style="{ zIndex: 10, maxHeight: '300px' }"
    :destroy-tooltip-on-hide="false"
    @hide="hide"
  >
    <template v-slot:trigger>
      <slot name="trigger">
        <MButton
          id="alert-btn"
          variant="neutral-lighter"
          :shadow="false"
          shape="circle"
          class="mx-2 cursor-pointer"
        >
          <MIcon name="exclamation-triangle" class="text-secondary-orange" />
        </MButton>
      </slot>
    </template>
    <div class="p-2">
      <span>
        {{
          `${$tc('used_by')} ${$tc('approval')} is ${$tc('pending')} ${$tc(
            'for'
          )} :`
        }}
      </span>
      <MDivider dark-variant />
      <div class="overflow-y-auto mb-2" :style="{ maxHeight: '150px' }">
        <span v-for="i in items || []" :key="i">
          <ul class="sorted-list">
            <li>
              <FlotoUserDrawer :user-id="i" />
            </li>
          </ul>
        </span>
      </div>
      <div class="flex justify-end">
        <UsedByHistoryDrawer
          :asset="asset"
          :module-name="moduleName"
          class="mx-1"
        >
          <template v-slot:trigger>
            <MButton variant="primary">
              {{ $tc('used_by') }} {{ $tc('history') }}
            </MButton>
          </template>
        </UsedByHistoryDrawer>
      </div>
    </div>
  </MPopover>
</template>
<script>
import UsedByHistoryDrawer from '../action-menu-items/used-by-history-drawer'
export default {
  name: 'PendingApprovalAlert',
  components: { UsedByHistoryDrawer },
  props: {
    asset: { type: Object, required: true },
    moduleName: { type: String, default: undefined },
    items: { type: Array, default: () => [] },
  },
  data() {
    return {
      isDrawerOpen: false,
    }
  },
  computed: {
    popoverPlacment() {
      return this.isRtl ? 'bottomRight' : 'bottomLeft'
    },
  },
  methods: {
    hide() {
      if (this.isDrawerOpen === true) {
        this.$refs.popover.hide()
      }
    },
  },
}
</script>
